import productModal from "@/js/alpine/productModal";
import searchSuggest from "@/js/alpine/searchSuggest";
import Alpine from 'alpinejs';

export default function () {
    productModal();
    searchSuggest();

    Alpine.start();
}
